import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

export default {
  computed: {
    fieldsClass() {
      return {
        address2: 'md:col-span-4',
        address5:
          getFeatureFlag(FEATURE_FLAG.GEMINI_TW) || getFeatureFlag(FEATURE_FLAG.HK_NEW_FORM) ? '' : 'md:col-span-8',
        address7: 'md:col-span-8',
        zip: 'md:col-span-4',
        streetNumber: 'sm:col-span-4',
        street1: 'sm:col-span-8',
      };
    },
  },
};
